export default "__VITE_ASSET__BrFUWT4d__"